import { styled } from '@clickcease/cc-client-components-lib'

export const GetTagModalContainer = styled('div', {
  background: '#FFFFFF',
  borderRadius: '$6',
  padding: '$5 0',
  display: 'flex',
  height: '100%',
  width: '100%',
  flexDirection: 'column',
})

export const GetTagModalDescription = styled('div', {
  display: 'flex',
  fontSize: '$md',
  fontWeight: 300,
  lineHeight: '$9',
  color: '$mainTextColor',
  whiteSpace: 'pre-line',
  padding: '$4 $12',
})

export const GetTagModalContent = styled('div', {
  display: 'flex',
  height: '100%',
  padding: '0 $12',
  marginTop: '$11',
})

export const GetTagModalFooter = styled('div', {
  display: 'flex',
  marginBlock: '$8',
  justifyContent: 'flex-end',
  borderTop: '1px solid rgba(239, 239, 239, 1)',
  justifySelf: 'flex-end',

  ['> button']: {
    marginRight: '$8',
    marginTop: '$5',
  },
})
